export class MemberPayStatements {
    payStatementList: PayStatementListItem[];
    currentPayStatementModel: PayStatementModel;
}

export class PayStatementListItem {
    payrollHeaderId: string;
    payPeriod: string;
    checkNumber: string;
    checkDate: string;
    checkAmount: string;
}
export class PayStatementPayload {
    payrollHeaderId: string;
    hyperlinkId: string;
}

export class PayStatementModel {
    payrollHeaderId: number;
    grossPay: number;
    preTax: number;
    postTax: number;
    totalTax: number;
    netPay: number;
    taxesTotalYTD: number;
    earningsTotalYTD: number;
    deductionsTotal: number;
    deductionsTotalYTD: number;
    employerPaidTotal: number;
    employerPaidTotalYTD: number;
    note: string;
    earningHoursWorkedTotal: number;
    payStatementEarnings: PayStatementEarning[];
    payStatementTaxes: PayStatementTax[];
    payStatementDeductions: PayStatementDeduction[];
    payStatementLeave: PayStatementLeave[];
    payStatementHeader: PayStatementHeader;
    payStatementDistribution: PayStatementDistribution;
}

export class PayStatementDistribution {
    uniqueID: string;
    payPeriod: string;
    checkNumber: string;
    checkDate: Date;
    checkAmount: number;
    bank: string[];
    directDepositAmount: string[];
    bankFormatted: string;
    directDepositAmountFormatted: string;
}

export class PayStatementHeader {
    companyName: string;
    companyAddressOne: string;
    companyAddressTwo: string;
    companyCityState: string;
    comCode: string;
    employeeName: string;
    employeeAddressOne: string;
    employeeAddressTwo: string;
    employeeCityState: string;
    employeeID: string;
    area: string;
    subArea: string;
    group: string;
    subGroup: string;
}

export class PayStatementLeave {
    uniqueID: string;
    leaveCode: string;
    hourAccrued: number;
    hourUsed: number;
    hourAvailable: number;
}

export class PayStatementDeduction {
    uniqueID: string;
    deductionCode: string;
    taxStatus: string;
    amount: number;
    ytdAmount: number;
    adjustmentPeriod: string;
}

export class PayStatementTax {
    uniqueID: string;
    taxCode: string;
    amount: number;
    ytdAmount: number;
}

export class PayStatementEarning {
    uniqueID: string;
    earningCode: string;
    rate: string;
    hours: string;
    amount: number;
    ytdAmount: number;
    adjustmentPeriod: string;
}

export class PayStatementTable {
    checkAmount: string;
    checkDate: Date;
    checkNumber: string;
    payrollHeaderId: number;
}